module.exports = {
  PROMOTION_TYPE: Object.freeze({
    DISCOUNT: 1,
    // GIFT: 2
  }),
};
